import React from 'react';
import IrrigationChart from '../../../../../../components/Highcharts/IrrigationChart/IrrigationChart';
import PhElectricityChart from '../../../../../../components/Highcharts/LineCharts/PhElectricityChart/PhElectricityChart';

const IrrigationChartsTab = ({
  sectorId, farmId,
}: { sectorId: string, farmId: string }) => (
  <>
    <IrrigationChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
      height={400}
      labelYPosition={312}
    />
    <PhElectricityChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
      height={400}
    />
  </>
);

export default IrrigationChartsTab;
